import { useEffect, useState } from "react"
import { Chapter } from "src/models/tieup/novel/Chapter"
import { Novel } from "src/models/tieup/novel/Novel"
import CommonLabel from "src/components/common/CommonLabel"
import TieupImg from "../../../../common/TieupImg"
import Link from "next/link"
import routes from "routes"
import StringUtil from "src/utils/StringUtils"

const MAX_OUTLINE_LENGTH_PC = 100
const MAX_OUTLINE_LENGTH_SP = 50

const NovelContent: React.FC<{ novel: Novel; onClose: () => void }> = ({
  novel,
  onClose,
}) => {
  const [truncateLength, setTruncateLength] = useState<number>(0)

  useEffect(() => {
    if (window.matchMedia("(max-width:321px)").matches) {
      setTruncateLength(MAX_OUTLINE_LENGTH_SP)
    } else {
      setTruncateLength(MAX_OUTLINE_LENGTH_PC)
    }
  }, [])

  const truncate = (text: string) => {
    return text.length <= truncateLength
      ? text
      : text.substring(0, truncateLength) + " ... "
  }

  const wordCount = (chapters: Chapter[]) => {
    return chapters.reduce((a, b) => {
      return a + b.word_count
    }, 0)
  }

  return (
    <div className="p-novelSimplified">
      <div className="p-novelSimplified-row">
        <div className="p-novelSimplified-image">
          <Link href={routes.creatorNovelsDetail(novel.id)}>
            <a
              onClick={() => onClose()}
              className="p-novelSimplified-image-anchor"
            >
              <TieupImg src={novel?.coverImage || "/img/cover.png"} />
            </a>
          </Link>
          {!!novel.user && (
            <p className="p-novelSimplified-creator">
              <Link href={routes.creatorUser(novel.user.display_name)}>
                <a
                  onClick={() => onClose()}
                  className="p-novelSimplified-creator-anchor js-novelSimplified-creator-trigger"
                >
                  {novel.user.name}
                </a>
              </Link>
            </p>
          )}
          {novel.readersNumber != undefined && (
            <p className="p-novelSimplified-bookmark">
              ブックマーク：
              {novel.readersNumber
                ? StringUtil.addComma(novel.readersNumber)
                : "-"}
            </p>
          )}
        </div>
        <div className="p-novelSimplified-detail">
          <p className="p-novelSimplified-copy">{novel.catchCopy}</p>
          <h2 className="p-novelSimplified-title">
            <Link href={routes.creatorNovelsDetail(novel.id)}>
              <a
                onClick={() => onClose()}
                className="p-novelSimplified-title-anchor"
              >
                {novel.title}
              </a>
            </Link>
          </h2>
          {!!novel.genres && (
            <ul className="p-searchNovalResult-genre">
              {novel.genres.map((genre) => (
                <li key={genre.id}>
                  <CommonLabel style="tertiary" text={genre.name} />
                </li>
              ))}
            </ul>
          )}
          {!!novel.hashtags && (
            <ul className="p-searchNovalResult-tag p-wordList-secondary">
              {novel.hashtags.map((h) => (
                <li key={h.id}>{h.name}</li>
              ))}
            </ul>
          )}
        </div>
      </div>
      {novel.outline !== undefined && (
        <>
          <p className="p-novelSimplified-summary-title">あらすじ</p>
          <div className="p-novelSimplified-summary-body">
            {novel.outline ? (
              <p>
                {truncate(novel.outline)}
                {novel.outline.length > truncateLength && (
                  <Link href={routes.creatorNovelsDetailTabDetail(novel.id)}>
                    <a onClick={() => onClose()}>続きを読む</a>
                  </Link>
                )}
              </p>
            ) : (
              <p>あらすじは未設定です。</p>
            )}
          </div>
        </>
      )}
      {!!novel.chapters && (
        <p className="p-novelSimplified-meta">
          文字数：{StringUtil.addComma(wordCount(novel.chapters))}字
        </p>
      )}
    </div>
  )
}

export default NovelContent
